import(/* webpackMode: "eager" */ "/workspace/online-customer-service-fe/app/error.tsx");
